// EAN-13 barcode renderer: receives a code (12 o 13 digitos) and returns a PNG dataURL.
// Si recibe 12 dígitos calcula el check digit. Si recibe 13, valida el check. Si el código no es
// válido, devuelve null y el caller decide qué hacer (por ejemplo no agregar imagen).

const L_PATTERNS = [
  "0001101","0011001","0010011","0111101","0100011",
  "0110001","0101111","0111011","0110111","0001011",
];
const G_PATTERNS = [
  "0100111","0110011","0011011","0100001","0011101",
  "0111001","0000101","0010001","0001001","0010111",
];
const R_PATTERNS = [
  "1110010","1100110","1101100","1000010","1011100",
  "1001110","1010000","1000100","1001000","1110100",
];
const FIRST_DIGIT_PATTERN = [
  "LLLLLL","LLGLGG","LLGGLG","LLGGGL","LGLLGG",
  "LGGLLG","LGGGLL","LGLGLG","LGLGGL","LGGLGL",
];

function checkDigit(num12) {
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const d = Number(num12[i]);
    sum += i % 2 === 0 ? d : d * 3;
  }
  return (10 - (sum % 10)) % 10;
}

export function ean13ToDataURL(code, options = {}) {
  const moduleWidth = options.moduleWidth || 3;
  const height = options.height || 80;
  const showText = options.showText !== false;
  const textSize = options.textSize || 16;
  const quietZone = options.quietZone || 10; // modulos en blanco a cada lado

  let clean = String(code || "").replace(/[^0-9]/g, "");
  if (clean.length === 0) return null;

  if (clean.length > 13) {
    // Si vienen más de 13 dígitos, recortar a los últimos 12 y recalcular check
    clean = clean.slice(-12);
  }
  if (clean.length < 12) {
    // Si son menos, padding con ceros a la izquierda hasta 12
    clean = clean.padStart(12, "0");
  }
  if (clean.length === 12) {
    clean = clean + String(checkDigit(clean));
  }
  // Si vienen 13 dígitos pero el check no cuadra, NO rechazamos:
  // renderizamos con el check declarado por el usuario (el scanner leerá las barras tal cual).
  if (clean.length !== 13) return null;

  const first = Number(clean[0]);
  const leftDigits = clean.slice(1, 7);
  const rightDigits = clean.slice(7, 13);
  const pattern = FIRST_DIGIT_PATTERN[first];

  // Construir cadena binaria total
  let bits = "101"; // start guard
  for (let i = 0; i < 6; i++) {
    const d = Number(leftDigits[i]);
    bits += pattern[i] === "L" ? L_PATTERNS[d] : G_PATTERNS[d];
  }
  bits += "01010"; // middle guard
  for (let i = 0; i < 6; i++) {
    bits += R_PATTERNS[Number(rightDigits[i])];
  }
  bits += "101"; // end guard

  // Dimensiones con quiet zones laterales
  const barsWidth = bits.length * moduleWidth;
  const totalWidth = barsWidth + quietZone * 2 * moduleWidth;
  const textHeight = showText ? textSize + 4 : 0;
  const canvas = document.createElement("canvas");
  canvas.width = totalWidth;
  canvas.height = height + textHeight;
  const ctx = canvas.getContext("2d");
  // fondo blanco
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  // barras (con offset por quiet zone)
  ctx.fillStyle = "#000000";
  const offsetX = quietZone * moduleWidth;
  for (let i = 0; i < bits.length; i++) {
    if (bits[i] === "1") {
      ctx.fillRect(offsetX + i * moduleWidth, 0, moduleWidth, height);
    }
  }
  if (showText) {
    ctx.fillStyle = "#000000";
    ctx.font = `bold ${textSize}px Helvetica, Arial, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(clean, totalWidth / 2, height + textHeight / 2);
  }
  return canvas.toDataURL("image/png");
}
